import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateSignUpType } from '@/modules/estate/enums/EstateSignUpType';
import { EstateSignUpFinancialAdvisorMeta } from '@/modules/estate/models/meta/EstateSignUpFinancialAdvisorMeta';
import { EstateSignUpMeta } from '@/modules/estate/models/meta/EstateSignUpMeta';

export class EstateSignUp extends BaseEntityModel {
  id?: number;
  userId?: number;
  type?: string;
  metaType?: string;
  isUpgrade: boolean;

  meta?: Relationship<EstateSignUpFinancialAdvisorMeta> | null;

  constructor(model: Partial<EstateSignUp> = {}) {
    super(model);

    this.id = model.id;
    this.userId = model.userId;
    this.type = model.type;
    this.isUpgrade = model.isUpgrade ?? false;
    this.metaType = model.metaType;

    this.meta = EstateSignUpMeta.factory(model);
  }

  get isClearVault(): boolean {
    return this.type === EstateSignUpType.CLEAR_VAULT;
  }

  get isStandardPlan(): boolean {
    return this.type === EstateSignUpType.STANDARD_PLAN;
  }

  get isBasicPlan(): boolean {
    return this.type === EstateSignUpType.BASIC_PLAN;
  }

  get isAftercare(): boolean {
    return this.type === EstateSignUpType.AFTERCARE;
  }

  get isSelfServePlan(): boolean {
    if (!this.type) {
      return false;
    }

    return [
      EstateSignUpType.BASIC_PLAN,
      EstateSignUpType.PARTNER_SELF_SERVE_PLAN,
      EstateSignUpType.STANDARD_PLAN,
      EstateSignUpType.DIGITAL_VAULT_PLAN
    ].includes(this.type);
  }

  get isPartnerSelfServePlan(): boolean {
    return this.type === EstateSignUpType.PARTNER_SELF_SERVE_PLAN;
  }

  get isFinancialAdvisor(): boolean {
    return this.type === EstateSignUpType.FINANCIAL_ADVISOR;
  }

  get isDigitalVaultPlan(): boolean {
    return this.type === EstateSignUpType.DIGITAL_VAULT_PLAN;
  }

  needsTriage(hasCurrentEstate: boolean): boolean {
    if (this.isSelfServePlan && !hasCurrentEstate) {
      return true;
    }

    if (this.isAftercare && !hasCurrentEstate) {
      return true;
    }

    return this.isClearVault || this.isFinancialAdvisor || this.isPartnerSelfServePlan;
  }
}
